import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import useSteps from '../../hooks/useSteps'
import Errors from '../Errors'

export default function PageTitle ({ step, children }) {

  const { getStep } = useSteps()

  const stepInfo = getStep(step)

  const getTitle = function () {
    return stepInfo?.headline ?? stepInfo.title
  }

  return (
    <div style={{ marginBottom: '40px' }}>
      <div className="mtt-template-content__title--title">
        <h1 className={classNames({ 'no-margin': !children })}>{getTitle()}</h1>
      </div>
      {
        typeof stepInfo.content === 'string'
          ? <div dangerouslySetInnerHTML={{ __html: stepInfo.content }}/>
          : null
      }
      <Errors/>
      {children}
    </div>
  )
}

PageTitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
}